var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-field flex flex-col mb-4"},[_c('label',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.label))]),_c('el-color-picker',{attrs:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }